import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useRequestPasswordResetMutation } from "../services/appApi";
import "./ForgotPassword.css";

function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [requestReset, { isLoading }] = useRequestPasswordResetMutation();
  const [errorMsg, setErrorMsg] = useState("");
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    if (!email.trim()) {
      setErrorMsg("Please enter your email address.");
      return;
    }

    const { data, error } = await requestReset({ email: email.trim() });

    if (error) {
      const msg =
        error?.data?.error ||
        "Something went wrong. Please try again.";
      setErrorMsg(msg);
      return;
    }

    // Always navigate — the backend returns the same generic message
    // whether the email exists or not, so we always proceed to OTP screen
    setSent(true);
    setTimeout(() => {
      navigate("/reset-password-otp", { state: { email: email.trim().toLowerCase() } });
    }, 800);
  };

  return (
    <div className="forgot-pw-root">
      <div className="forgot-pw-card">
        {/* Icon */}
        <div className="forgot-pw-icon-wrap" aria-hidden="true">
          🔒
        </div>

        <h1 className="forgot-pw-title">Forgot your password?</h1>
        <p className="forgot-pw-subtitle">
          Enter the email address you registered with. We'll send you a 6-digit
          code to reset your password.
        </p>

        {/* Error */}
        {errorMsg && (
          <div className="forgot-pw-error" role="alert">
            <span aria-hidden="true">⚠️</span> {errorMsg}
          </div>
        )}

        {/* Success flash */}
        {sent && (
          <div className="forgot-pw-success" role="status">
            ✓ If an account exists, a reset code was sent. Redirecting…
          </div>
        )}

        <form onSubmit={handleSubmit} noValidate>
          <div className="forgot-pw-input-wrap">
            <input
              id="forgot-email"
              type="email"
              className="forgot-pw-input"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
              autoComplete="email"
              disabled={sent}
            />
          </div>

          <button
            type="submit"
            className="forgot-pw-btn"
            disabled={isLoading || sent}
          >
            {isLoading ? (
              <>
                <span className="btn-spinner" aria-hidden="true" />
                Sending…
              </>
            ) : sent ? (
              "Code sent ✓"
            ) : (
              "Send reset code"
            )}
          </button>
        </form>

        <div className="forgot-pw-footer">
          Remember your password?{" "}
          <Link to="/login" className="forgot-pw-link">
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
